"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProviderFromUrl = void 0;
const ethers_1 = require("ethers");
function getProviderFromUrl(rpcUrl) {
    const timeoutMs = 2 * 60 * 1000;
    const provider = new ethers_1.providers.StaticJsonRpcProvider({
        url: rpcUrl,
        timeout: timeoutMs,
        throttleLimit: 1
    });
    return provider;
}
exports.getProviderFromUrl = getProviderFromUrl;
